import styled from 'styled-components'
import { Form } from 'components/forms'
import { FormCol } from 'style/styled'

export const StyledPmsForm = styled(Form)`
	& .textAlignRight input{
		text-align: right;
	}
`

export const StyledFormRowWithAdditionalLabel = styled(FormCol)`
	display: flex;
	align-items: center;
	& span{
		margin-left: 10px;
	}
`
